import {Stack, SxProps, Theme, Typography} from '@mui/material';
import {Modal} from '../../modal/modal';
import {useTranslation} from 'react-i18next';
import {translations} from '../../../i18n/translations';
import {useState} from 'react';

type DailyCareLogModalProps = {
  open: boolean;
  title: string;
  subtitle?: string;
  onClose: () => void;
  onConfirm: () => Promise<void>;
};

export const DailyCareLogModal = ({
  open,
  title,
  subtitle,
  onClose,
  onConfirm,
}: DailyCareLogModalProps) => {
  const {t} = useTranslation();
  const [saving, setSaving] = useState(false);

  const modalSx: SxProps<Theme> = {
    marginBottom: 0,
    '.MuiPaper-root': {
      width: '554px',
      borderRadius: '16px',
    },
    '& > .MuiButtonBase-root': {
      lineHeight: '24px',
      height: '36px',
      width: '77px',
      paddingX: '14px',
      borderRadius: '5px',
    },
    '& > .MuiDialogContent-root': {
      paddingBottom: 0,
    },
  };

  const wrapperSx: SxProps<Theme> = {
    height: '86px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  };

  const innerWrapperSx: SxProps<Theme> = {
    display: 'flex',
    gap: '18px',
    width: '227px',
  };

  const titleSx: SxProps<Theme> = {
    fontSize: '16px',
    fontWeight: 500,
    lineHeight: '24px',
    letterSpacing: '0em',
    textAlign: 'center',
    color: 'var(--dcm-gray)',
  };

  const subtitleSx: SxProps<Theme> = {
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '21px',
    letterSpacing: '0em',
    textAlign: 'center',
    color: 'var(--dcm-gray-general)',
  };

  return (
    <Modal
      open={open}
      actions={[
        {
          label: t(translations.care_and_activities.handle_task_modal.cancel),
          type: 'destructive',
          onClick: onClose,
        },
        {
          label: t(translations.care_and_activities.handle_task_modal.confirm),
          type: 'nondestructive',
          loading: saving,
          disabled: saving,
          onClick: async () => {
            setSaving(true);
            await onConfirm();
            setSaving(false);
          },
        },
      ]}
      sx={modalSx}
      preventCloseClick
    >
      <Stack sx={wrapperSx}>
        <Stack sx={{...innerWrapperSx, width: 'unset'}}>
          <Typography sx={titleSx}>{title}</Typography>
          {subtitle && <Typography sx={subtitleSx}>{subtitle}</Typography>}
        </Stack>
      </Stack>
    </Modal>
  );
};
